/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_None_PastInputs */



/**
* | output |
* | --- |
* | "No past tournaments." |
*
* @param {Tournaments_None_PastInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_none_past = /** @type {((inputs?: Tournaments_None_PastInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_None_PastInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun tournoi passé.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay torneos pasados.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhum torneio passado.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun torneo passato.")
	return /** @type {LocalizedString} */ ("No past tournaments.")
});